module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 h5"
  }, [_vm._v("\n        ผู้ใช้งาน : " + _vm._s(_vm.getAuthen.typename) + " " + _vm._s(_vm.getAuthen.orgcode) + "\n        "), _c('br'), _vm._v(_vm._s(_vm.getAuthen.orgname) + "\n        "), _c('br'), _vm._v(_vm._s(_vm.getAuthen.register_name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group text-center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "id": "btn_logout",
      "name": "btn_logout",
      "type": "button",
      "value": "ออกจากระบบ"
    },
    on: {
      "click": _vm.clickButtonLogout
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h4', [_vm._v(" ยินดีต้อนรับเข้าสู่ระบบ ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b75dcaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginInfo.vue
// module id = 1090
// module chunks = 1